export default function getNombreEstado(estado) {
    return estado ? 'Activo' : 'Inactivo'
}